import React from 'react';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

function Pesky() {
  return (
    <div className=''>
      <div className='pad boost-container centered-text'>
        <span className='large-text4'>
          <TranslateText text="DO YOU HAVE PESKY" />
        </span>
        <span className='large-text4'>
          <TranslateText text="CREDIT INQUIRIES?" />
        </span>
        <div className="separator2"></div>
        <div className='push'></div>
        <span className='large-text'>
          <TranslateText text="IF YOU HAVE TOO MANY, YOU WILL GET DENIED MORE FREQUENTLY WHICH WILL HOLD YOU BACK FROM THE" />
        </span>
        <span className='large-text'>
          <TranslateText text="THINGS YOU WANT TO GET IN YOUR LIFE." />
        </span>
        <span className='large-text'>
          <TranslateText text="WE REMOVE CERTAIN PESKY CREDIT INQUIRIES THAT ARE RUINING YOUR CREDIT SCORE SO YOU CAN START" />
        </span>
        <span className='large-text'>
          <TranslateText text="GETTING APPROVALS AGAIN!" />
        </span>
      </div>
    </div>
  );
}

export default Pesky;

// import React from 'react'

// function Pesky() {
//   return (
//     <div className=''>
//       <div className='pad boost-container centered-text'>
//         <span className='large-text4'>DO YOU HAVE PESKY </span>
//         <span className='large-text4 '>CREDIT INQUIRIES? </span>
//         <div className="separator2"></div>
//         <div className='push'></div>
//         <span className='large-text'>IF YOU HAVE TOO MANY, YOU WILL GET DENIED MORE FREQUENTLY WHICH WILL HOLD YOU BACK FROM THE </span>
//         <span className='large-text'>THINGS YOU WANT TO GET IN YOUR LIFE.</span>
//         <span className='large-text'>WE REMOVE CERTAIN PESKY CREDIT INQUIRIES THAT ARE RUINING YOUR CREDIT SCORE SO YOU CAN START</span>
//         <span className='large-text'>GETTING APPROVALS AGAIN!</span>




//          </div>
//     </div>
//   )
// }

// export default Pesky
